module.exports = __webpack_public_path__ + "img/about.6002e1e4.jpg";